import moment from 'moment';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// isBefore :: ISODate|String, ISODate|String -> Boolean

const isBefore = (date1, date2) => moment(date1).isBefore(date2);

export default isBefore;
